/** ---- Common ---- */
export const BENEFICIAIRE_EFFECTIF_FIELDS_EPARGNE = {
  CIVILITE: 'civilite',
  NOM: 'nom',
  PRENOM: 'prenom',
  NOM_NAISSANCE: 'nomNaissance',
  ACTIVITE: 'activiteBeneficiaire',
  FONCTION_DIRIGEANT: 'fonctionDirigeant',
  IS_PERSONNE_MORALE: 'beneficiaireIsPersonneMorale',
  QUALITE: 'qualite',
  RAISON_SOCIALE: 'raisonSociale',
  PARTS: 'parts',
  PAYS_FISCAL: 'paysFiscal',

  // Main Address
  RUE: 'adressePermanenteRue',
  CODE_POSTAL: 'adressePermanenteCode',
  VILLE: 'adressePermanenteVille',

  // Company Adress
  SAME_ADDRESS_COMPANY: 'isSameAddress',
  VILLE_ENTREPRISE: 'adressePostaleVille',
  CODE_POSTAL_ENTREPRISE: 'adressePostaleCode',
  RUE_ENTREPRISE: 'adressePostaleRue'
};

export const QUALITE_ACTIONNNAIRE = {
  PRINCIPAL: 'A',
  BENEFICIAIRE: 'B',
  DIRIGEANT: 'D',
  PROCURATION: 'P'
};

export const QUALITES = [
  {
    label: 'Actionnaire Principal',
    value: QUALITE_ACTIONNNAIRE.PRINCIPAL
  },
  {
    label: 'Bénéficiaire effectif',
    value: QUALITE_ACTIONNNAIRE.BENEFICIAIRE
  },
  {
    label: 'Dirigeant',
    value: QUALITE_ACTIONNNAIRE.DIRIGEANT
  },
  {
    label: 'Procuration',
    value: QUALITE_ACTIONNNAIRE.PROCURATION
  }
];